import { render } from "./ModificacionCentroCosto.vue?vue&type=template&id=5cf97692"
import script from "./ModificacionCentroCosto.vue?vue&type=script&lang=js"
export * from "./ModificacionCentroCosto.vue?vue&type=script&lang=js"

import "../formulario.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__